<script setup lang="ts">
import gsap from 'gsap';

interface Props {
	appear?: boolean
	mode?: "in-out" | "out-in" | "default"
}
defineProps<Props>();

function onBeforeEnter(el) {
	gsap.set(el, {
		height: 0,
		overflow: 'hidden',
	});
}

function onEnter(el, done) {
	const sectionHeight = el.scrollHeight;
	gsap.fromTo(
		el,
		{ height: 0 },
		{
			height: sectionHeight,
			duration: 0.3,
			ease: 'power2.in',
			onComplete: done
		}
	);
}

function onAfterEnter(el) {
	gsap.set(el, {
		height: "auto",
		overflow: null,
	});
}

function onBeforeLeave(el) {
	gsap.set(el, {
		overflow: 'hidden',
	});
}

function onLeave(el, done) {
	const sectionHeight = el.scrollHeight;
	gsap.fromTo(
		el,
		{ height: sectionHeight },
		{
			height: 0,
			duration: 0.3,
			ease: 'power2.in',
			onComplete: done
		}
	);
}

</script>
<template>
	<Transition name="measurements-height" appear :mode="mode" @before-enter="onBeforeEnter" @enter="onEnter" @after-enter="onAfterEnter" @before-leave="onBeforeLeave" @leave="onLeave" :css="false">
		<slot></slot>
	</Transition>
</template>
